<template>
  <div class="content-container flex-column">
    <!-- Kontrakt Toolbar -->
    <div class="grid-x toolbar fixed responsive-small-only">
      <div class="cell auto toolbar-responsive">
        <ul class="toolbar-title-breadcrumbs">
          <li>
            <a href="javascript:;" @click="hideMultiInvoice()">{{kunde.full_name}}</a>
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-right"></use></svg>
          </li>
          <li>
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-right"></use></svg>
          </li>
        </ul>
      </div>
    </div>

    <!-- Content -->
    <div class="content-container flex-row no-flex-grow">
      <overlay-scrollbars :options="{ className: 'content-container flex-column os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
        <section class="content xlarge-padding border-bottom">
          <TheLoader :active="$store.getters.isFormLoading" :small="true"/>

          <div class="grid-x">
            <div class="cell auto">
              <span class="icon-heading-title">
                <span class="title">Faktura</span>
              </span>
            </div>
            <div class="cell shrink">
                <span class="button-container has-popover" :class="{'popover-active': formPopoverActive}"
                      @click="toggleFormPopover()">
                  <span class="button action glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
                    xlink:href="/static/sprites.svg#button-glyph-edit"></use></svg> <span>Innstillinger</span></span>
                  <span class="popover popover-has-footer align-x-right align-y-bottom medium">
                    <ul>
                      <li>
                        <TheSwitchInputPopover v-model="form.Export" label="Eksport" labelTrue="" labelFalse=""
                                               trueValue="T" falseValue="F"/>
                      </li>
                      <li :class="{'disabled': form.Export !== 'T'}">
                        <TheSwitchInputPopover v-model="form.Mvafri" label="Mvafri" labelTrue="" labelFalse=""
                                               trueValue="T" falseValue="F" :disabled="form.Export !== 'T'"/>
                      </li>
                    </ul>
                  </span>
                </span>
              </div>
           </div>
          <table class="medium padding margin-top margin-bottom">
            <template v-for="obj in objektWithBilag" >
              <thead :key="'head-' + obj.Objektnr">
                <tr>
                  <td colspan="2"><strong>{{obj.Objektnr}}</strong></td>
                  <td colspan="3" class="align-right">
                    <span class="button-container has-popover" :class="{'popover-active': isVarePopoverActive(obj.Objektnr)}" @click="toggleVarePopover(obj.Objektnr)">
                      <span class="button action glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg> <span>Ny fakturalinje</span></span>
                      <span class="popover align-x-right align-y-bottom xlarge">
                        <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
                        <ul>
                          <li v-for="item in getVarePopoverOptions(obj).sort(sortLinevalues)" v-bind:key="'add-' + item.data.Vareid">
                            <a href="javascript:;" @click="addVare(obj, item)" class="add-form-line popover-form-line"><span>{{item.data.Beskrivelse || item.val}} <span class="label">{{item.val}}</span></span></a>
                          </li>
                        </ul>
                        </overlay-scrollbars>
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <th>Beskrivelse</th>
                  <th>Kode</th>
                  <th class="align-right">Pris eks. mva</th>
                  <th class="align-right">Pris inkl. mva</th>
                  <th class="align-right">&nbsp;</th>
                </tr>
              </thead>
              <tbody :key="'body-' + obj.Objektnr">
                <tr v-for="line in obj.bilag_draft.bilagslinje" :key="obj.Objektnr + '-' + line.Internalid">
                  <td>
                    <div class="input-container minimal no-margin large text">
                      <input type="text" v-model="line.Beskrivelse" maxlength="100">
                      <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg></span>
                    </div>
                  </td>
                  <td>
                    <span class="label">{{line.Varenr}}</span>
                  </td>
                  <td class="align-right opacity-60">
                    {{line.Belop | thousandsFloat}}
                  </td>
                  <td class="align-right">
                    <TheDecimalInputTable v-model="line.Beloptotal" containerClassName="input-container minimal align-right no-margin small" @blur="onValueChange($event, obj, line)"/>
                  </td>
                  <td class="align-right">
                    <a href="javascript:;" v-if="line.Varetype != 'O'" @click="delVare(obj, line)" class="button action input-action glyph glyph-only no-margin"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg></a>
                  </td>
                </tr>
                <tr><td colspan="5"><br></td></tr>
              </tbody>
            </template>
            <tfoot class="highlight">
              <tr>
                <td colspan="2"><strong>Total</strong></td>
                <td class="align-right"><strong>{{totalPriceExc}}</strong></td>
                <td class="align-right"><strong>{{totalPriceInc}}</strong></td>
                <td>&nbsp;</td>
              </tr>
            </tfoot>
          </table>

          <div class="grid-x">
            <div class="cell auto"></div>

            <!-- Normal invoice -->
            <div class="cell shrink">
              <a v-if="!$store.getters.isFormLoading && !$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large" @click="openSaveModal()">Opprett faktura</a>
              <a v-else href="javascript:;" class="button primary submit large" disabled>Opprett faktura</a>
            </div>
          </div>
        </section>
      </overlay-scrollbars>
    </div>
  </div>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import InstillingerService from '@/services/InstillingerService'
import bus from '@/plugins/event-bus'
import moment from 'moment'
import accounting from 'accounting-js'

const SALAR_MAP = {
  'AL': 15.3846153845,
  'BL': 15.3846153845,
  'CL': 15.3846153845,
  'DL': 15.3846153845,
  'EL': 15.3846153845,
  'UL': 20,
  'ZL': 20,
  'FL': 25,
  'GL': 25,
  'HL': 25,
  'IL': 25,
  'JL': 25,
  'KL': 25,
  'LL': 25,
  'ML': 25,
  'NL': 25,
  'OL': 25,
  'PL': 25,
  'QL': 25,
  'RL': 25,
  'SL': 25,
  'TL': 25,
  'VL': 25,
  'WL': 25,
  'XL': 25,
  'YL': 25,
  'ÆL': 25,
  'ØL': 0,
  'ÅL': 0,
  // Sentrum
  'AS': 15.3846153845,
  'BS': 15.3846153845,
  'CS': 15.3846153845,
  'DS': 15.3846153845,
  'ES': 15.3846153845,
  'US': 20,
  'ZS': 20,
  'FS': 25,
  'GS': 25,
  'HS': 25,
  'IS': 25,
  'JS': 25,
  'KS': 25,
  'LS': 25,
  'MS': 25,
  'NS': 25,
  'OS': 25,
  'PS': 25,
  'QS': 25,
  'RS': 25,
  'SS': 25,
  'TS': 25,
  'VS': 25,
  'WS': 25,
  'XS': 25,
  'YS': 25,
  'ÆS': 25,
  'ØS': 0,
  'ÅS': 0
}

const KUNST_MAPPING = [
  'AL',
  'BL',
  'CL',
  'DL',
  'EL',
  'AS',
  'BS',
  'CS',
  'DS',
  'ES'
]

/** Lagerleie varekode per department (Avdelingsid). null = default/fallback */
const LAGERLEIE_VAREKODE_CONFIG = [
  { avdelingsid: 2, varekode: 'LLUKE2' }, // Vin
  { avdelingsid: null, varekode: 'LLUKE' } // Default
]

const getLagerleieVarekode = (avdelingsid) => {
  const config = LAGERLEIE_VAREKODE_CONFIG.find(c => c.avdelingsid === avdelingsid) ||
                 LAGERLEIE_VAREKODE_CONFIG.find(c => c.avdelingsid === null)
  return config ? config.varekode : 'LLUKE'
}

export default {
  name: 'KundeFakturerMultiple',
  props: {
    kunde: {
      type: Object,
      required: true
    },
    objektList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loaded: 0,
      internal: {
        Utlevert: false,
        Lagerleie: false
      },
      form: {
        Bilagstype: 'F',
        Retur: 'F',
        Export: 'F',
        Mvafri: 'F',
        objektdata: {
          Mottaker: null,
          Auksjon: null
        }
      },
      vareList: [],
      vareOptionsUsed: {},
      varePopoverActive: {},
      formPopoverActive: false,
      objektWithBilag: []
    }
  },
  created () {
    bus.$off('bilag-kunde-updated')
    bus.$off('invoice-created')

    var vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.varePopoverActive = {}
        vm.formPopoverActive = false
      }
    })

    this.$set(this.form.objektdata, 'Mottaker', this._.cloneDeep(this.kunde))
    // this.form.objektdata.Mottaker = this._.clone(this.kunde)

    this.setFormLoading(true)
    this.fetch()
    this.fetchDrafts()
  },
  mounted () {
    bus.$on('bilag-kunde-updated', (data) => this.onKundeAddressUpdated(data))
    bus.$on('invoice-created', (data) => this.onInvoiceCreated(data))
  },
  watch: {
    loaded: function (newVal) {
      if (newVal >= 2) {
        this.setFormLoading(false)
      }
    },
    'form.Export': function (newVal) {
      if (newVal === 'F') {
        this.form.Mvafri = 'F'
      }
    },
    'form.Mvafri': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.recalcAll()
      }
    },
    'internal.Utlevert': function (newVal) {
      if (newVal === false) {
        this.internal.Lagerleie = false
      }
    },
    'internal.Lagerleie': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.toggleLagerLeieLines()
      }
    }
  },
  computed: {
    totalPriceInc: function () {
      let retval = 0

      this.objektWithBilag.forEach((obj) => {
        obj.bilag_draft.bilagslinje.forEach((line) => {
          if (line.Beloptotal !== null && line.Beloptotal !== '') {
            retval += parseFloat(line.Beloptotal)
          }
        })
      })

      return accounting.formatNumber(retval, { precision: 2, thousand: ' ' })
    },
    totalPriceExc: function () {
      let retval = 0

      this.objektWithBilag.forEach((obj) => {
        obj.bilag_draft.bilagslinje.forEach((line) => {
          if (line.Belop !== null && line.Belop !== '') {
            retval += parseFloat(line.Belop)
          }
        })
      })

      return accounting.formatNumber(retval, { precision: 2, thousand: ' ' })
    }
  },
  methods: {
    onInvoiceCreated: function (data) {
      this.$helpers.showSuccessAlert('Faktura er lagret')
      this.hideMultiInvoice()
    },
    onValueChange: function (event, objekt, line) {
      let index = objekt.bilag_draft.bilagslinje.findIndex(x => x.Internalid === line.Internalid)

      if (index === -1) {
        return
      }

      if (line.Varenr === objekt.Objektnr) {
        this.recalcObjekt(objekt, false, false, line)
        this.recalcKunstnerAvgift(objekt, line)
      } else if (line.Varenr === 'SALÆR') {
        this.recalcSalar(objekt, line)
        this.recalcKunstnerAvgift(objekt, line)
      } else {
        this.recalcLine(objekt, line)
      }

      // if (line.Varenr === objekt.Objektnr) {
      //   if (Number(objekt.bilag_draft.bilagslinje[index].Pris) !== Number(this.currentObjektPris(objekt))) {
      //     this.recalcObjekt(objekt)
      //     this.recalcKunstnerAvgift(objekt)
      //   } else {
      //     let updated = {
      //       Belop: accounting.formatNumber(objekt.bilag_draft.bilagslinje[index].Belop, {precision: 2, thousand: ''})
      //     }
      //     this.$set(objekt.bilag_draft.bilagslinje, index, Object.assign({}, objekt.bilag_draft.bilagslinje[index], updated))
      //   }
      // } else if (line.Varenr === 'SALÆR') {
      //   if (Number(objekt.bilag_draft.bilagslinje[index].Pris) !== Number(this.currentSalarPris(objekt))) {
      //     this.recalcSalar(objekt)
      //     this.recalcKunstnerAvgift(objekt)
      //   } else {
      //     let updated = {
      //       Belop: accounting.formatNumber(objekt.bilag_draft.bilagslinje[index].Belop, {precision: 2, thousand: ''})
      //     }
      //     this.$set(objekt.bilag_draft.bilagslinje, index, Object.assign({}, objekt.bilag_draft.bilagslinje[index], updated))
      //   }
      // } else {
      //   if (Number(objekt.bilag_draft.bilagslinje[index].Pris) !== Number(line.Belop)) {
      //     this.recalcLine(objekt, line)
      //   } else {
      //     let updated = {
      //       Belop: accounting.formatNumber(objekt.bilag_draft.bilagslinje[index].Belop, {precision: 2, thousand: ''})
      //     }
      //     this.$set(objekt.bilag_draft.bilagslinje, index, Object.assign({}, objekt.bilag_draft.bilagslinje[index], updated))
      //   }
      // }
    },
    toggleLagerLeieLines: function () {
      this.objektWithBilag.forEach((obj) => {
        let index = obj.bilag_draft.bilagslinje.findIndex(line => line.Varenr === getLagerleieVarekode(obj.Avdelingsid))

        if (index === -1) {
          // Objekt have NO lagerleie
          if (this.internal.Lagerleie) {
            this.addLagerLeie(obj)
          }
        } else {
          // Objekt have lagerleie
          if (!this.internal.Lagerleie) {
            obj.bilag_draft.bilagslinje.splice(index, 1)
          }
        }
      })
    },
    fetch: function () {
      InstillingerService('vare').dropdownByParams({ type: 'K' })
        .then((response) => {
          // Get result and add a used property
          this.vareList = response.data.map(obj => ({ ...obj, Used: false }))
        })
        .catch((e) => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn instillinger')
        })
        .then(() => {
          ++this.loaded
        })
    },

    fetchDrafts: function () {
      ObjektService.getObjektBilagList({ list: this.objektList })
        .then((response) => {
          this.setupObjektBilagLines(response.data)
        })
        .catch((error) => {
          console.log('Error in fetchDrafts')
          console.error(error)
        })
        .then(() => {
          ++this.loaded
        })
    },
    recalcAll: function () {
      this.objektWithBilag.forEach(objekt => {
        objekt.bilag_draft.bilagslinje.forEach(line => {
          if (line.Varenr === objekt.Objektnr) {
            this.recalcObjekt(objekt, false, true, line)
            // this.recalcKunstnerAvgift(objekt)
          } else if (line.Varenr === 'SALÆR') {
            this.recalcSalar(objekt, line, true)
            // this.recalcKunstnerAvgift(objekt)
          } else if (line.Varenr === 'BKH') {
            this.recalcKunstnerAvgift(objekt, line, true)
          } else {
            this.recalcLine(objekt, line, true)
          }
        })
      })
    },
    recalcLine: function (objekt, currLine, mvaChanged) {
      let index = objekt.bilag_draft.bilagslinje.findIndex(x => x.Internalid === currLine.Internalid)

      if (index !== -1) {
        const vidx = this.vareList.findIndex(x => x.data.Varekode === currLine.Varenr)
        const item = this.vareList[vidx]

        // let Pris = parseFloat(currLine.Belop || 0)

        // if (this.form.Mvafri === 'F') {
        //   // Must increase by possible MVA, as it will be reduced in the makeVareLine method.
        //   if (Pris > 0 && item.data.Prisinclmva === 'T' && item.data.mva && item.data.mva.Mvapct) {
        //     Pris = Pris * ((100 + parseInt(item.data.mva.Mvapct)) / 100)
        //   }
        // }

        let Pris = 0
        if (mvaChanged) {
          // Must recalc to exclude mva
          if (this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct) {
            Pris = currLine.Pris * ((100 + parseInt(item.data.mva.Mvapct)) / 100)
          } else {
            Pris = currLine.Pris
          }
        } else {
          Pris = parseFloat(currLine.Beloptotal || 0)
        }

        const data = {
          Antall: 1,
          Pris: Pris,
          Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Beskrivelse: objekt.bilag_draft.bilagslinje[index].Beskrivelse || item.data.Beskrivelse,
          Internaldel: true,
          Internaledit: true
        }

        // Make line
        const line = this.makeVareLine(objekt, item, data, true)

        // Merge new data with old, and keep reactivity - hence Object assign
        this.$set(objekt.bilag_draft.bilagslinje, index, Object.assign({}, objekt.bilag_draft.bilagslinje[index], line))
      }
    },
    setupObjektBilagLines: function (items) {
      items.forEach(o => {
        let objektData = []
        objektData = this._.clone(o)

        if (!objektData.bilag_draft) {
          /**
           * Have no bilag and no lines, so make default
           */
          objektData.bilag_draft = {
            Internalid: 'new-bilag-' + objektData.Objektnr,
            bilagslinje: []
          }

          this.addObjekt(objektData)

          // 2. Add Salar
          this.addSalar(objektData)

          // 3. Add Kunstnersavgift
          if (this.hasBKH(objektData)) {
            this.addKunstnersavgift(objektData, false)
          }

          // 4. Add Lagerleie
          if (this.lagerleieWeeks(objektData) !== null) {
            this.addLagerleie(objektData, false)
          }

          this.objektWithBilag.push(objektData)
        } else if (!objektData.bilag_draft.bilagslinje) {
          /**
           * Have bilag but no lines, so add empty array
           */
          objektData.bilag_draft.Internalid = objektData.bilag_draft.Bilagsid
          objektData.bilag_draft.bilagslinje = []
          this.objektWithBilag.push(objektData)
        } else {
          /**
           * Have bilag + lines -> parse and format lines
           */

          // Make a copy of current bilaglines for looping
          const linesCopy = this._.clone(objektData.bilag_draft.bilagslinje)

          // Reset current bilaglines
          objektData.bilag_draft.Internalid = objektData.bilag_draft.Bilagsid
          objektData.bilag_draft.bilagslinje = []

          // Loop and remove the ones not needed
          linesCopy.forEach(line => {
            if (line.Varenr === 'SALÆR' || line.Varenr === 'OPPGJØR') {
              return
            }
            if (line.Varenr === objektData.Objektnr) {
              line.Belop = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Beloptotal = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Pris = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Mvagrunnlag = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Mvabelop = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Internalid = line.Bilagslinjeid
              line.Internaledit = false
              line.Internaldel = false
            } else {
              line.Internalid = line.Bilagslinjeid
              line.Internaledit = true
              line.Internaldel = true
              line.Beskrivelse = line.Beskrivelse || line.Varenr
              line.Beloptotal = accounting.formatNumber((line.Belop || 0) + (line.Mvabelop || 0), { precision: 2, thousand: '' })
              line.Pris = accounting.formatNumber(line.Pris || 0, { precision: 2, thousand: '' })
              line.Belop = accounting.formatNumber(line.Belop || 0, { precision: 2, thousand: '' })
              line.Mvagrunnlag = accounting.formatNumber(line.Belop || 0, { precision: 2, thousand: '' })
              line.Mvabelop = accounting.formatNumber(line.Mvabelop || 0, { precision: 2, thousand: '' })
            }

            objektData.bilag_draft.bilagslinje.push(line)
          })

          this.objektWithBilag.push(objektData)
        }
      })
    },
    addLagerleie: function (objekt, deletable) {
      const index = this.vareList.findIndex(x => x.data.Varekode === getLagerleieVarekode(objekt.Avdelingsid))

      if (index === -1) {
        return
      }

      const item = this.vareList[index]
      const data = {
        Antall: this.lagerleieWeeks(objekt).weeks,
        Pris: item.data.Pris ? parseFloat(item.data.Pris) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse + ' (' + this.lagerleieWeeks(objekt).from + ' - ' + this.lagerleieWeeks(objekt).till + ')',
        Internaldel: deletable,
        Internaledit: true
      }

      // Make line
      const line = this.makeVareLine(objekt, item, data)
      this.addBilagLine(objekt, line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    addBilagLine: function (objekt, item) {
      objekt.bilag_draft.bilagslinje.push(item)
    },
    lagerleieWeeks: function (objekt) {
      // Check objekt
      if (!objekt.Lagerleieinfo || !objekt.Lagerleiedato) {
        return null
      }

      // Also check mottaker
      if (!objekt.mottaker || !objekt.mottaker.SendLagerleieinfo) {
        return null
      }

      const today = moment().format('YYYY-MM-DD')
      const ldato = moment(moment(objekt.Lagerleiedato).format('YYYY-MM-DD'))
      const diff = ldato.diff(today)

      // Only if today or less than today's date
      if (diff <= 0) {
        const totd = Math.abs(moment.duration(diff).as('days'))
        const totw = Math.floor(totd / 7) + ((totd % 7) > 0 ? 1 : 1)
        // weeks from object
        const weeks = objekt.lagerleie_weeks ? objekt.lagerleie_weeks : totw

        return {
          weeks: weeks,
          from: ldato.format('YYYY-MM-DD'),
          till: today
        }
      }

      return null
    },
    hasBKH: function (objekt) {
      return KUNST_MAPPING.includes(objekt.Kategori)
    },
    addObjekt: function (objekt) {
      let title = objekt.title + (objekt.subtitle ? ' / ' + objekt.subtitle : '')
      const index = this.vareList.findIndex(x => x.data.Varekode === 'OBJEKT')

      if (index === -1) {
        return
      }

      const item = this.vareList[index]

      const data = {
        Antall: 1,
        Pris: objekt.Salgspris ? parseFloat(objekt.Salgspris) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'O',
        Varenr: objekt.Objektnr,
        Beskrivelse: title,
        Internaldel: false,
        Internaledit: false
      }

      const line = this.makeVareLine(objekt, item, data)

      objekt.bilag_draft.bilagslinje.push(line)

      this.$set(this.vareOptionsUsed, objekt.Objektnr + ':' + item.data.Varekode, true)
    },
    currentObjektPris: function (objekt) {
      const index = objekt.bilag_draft.bilagslinje.findIndex(x => x.Varenr === objekt.Objektnr)

      if (index !== -1) {
        return objekt.bilag_draft.bilagslinje[index].Belop
      }

      return 0
    },
    currentSalarPris: function (objekt) {
      const index = objekt.bilag_draft.bilagslinje.findIndex(x => x.Varenr === 'SALÆR')

      if (index !== -1) {
        return objekt.bilag_draft.bilagslinje[index].Belop
      }

      return 0
    },
    recalcKunstnerAvgift: function (objekt, currLine, mvaChanged) {
      const index = objekt.bilag_draft.bilagslinje.findIndex(x => x.Varenr === 'BKH')

      this.bkh = this.currentObjektPris(objekt) >= 1600

      if (index === -1) {
        return
      }

      const vidx = this.vareList.findIndex(x => x.data.Varekode === 'BKH')
      const item = this.vareList[vidx]

      let Pris = this.currentObjektPris(objekt) >= 1600 ? parseFloat(this.currentObjektPris(objekt) || 0) + parseFloat(this.currentSalarPris(objekt) || 0) : 0

      if (mvaChanged) {
        // Must recalc to exclude mva
        if (this.currentObjektPris(objekt) < 1600) {
          Pris = 0
        } else if (this.form.Mvafri === 'F') {
          Pris = parseFloat(this.currentObjektPris(objekt) || 0) + parseFloat(this.currentSalarPris(objekt) || 0)
        } else {
          let salarIndex = this.vareList.findIndex(x => x.data.Varekode === 'SALÆR')
          let salarItem = this.vareList[salarIndex]
          let Salar = parseFloat(this.currentSalarPris(objekt) || 0) / ((100 + parseInt(salarItem.data.mva.Mvapct)) / 100)

          Pris = parseFloat(this.currentObjektPris(objekt) || 0) + parseFloat(Salar)
        }
      }

      const data = {
        Antall: 0.05,
        Pris: Pris,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: objekt.bilag_draft.bilagslinje[index].Beskrivelse || item.data.Beskrivelse,
        Internaldel: true,
        Internaledit: false
      }

      // Make line
      const line = this.makeVareLine(objekt, item, data, true)

      // Merge new data with old, and keep reactivity - hence Object assign
      this.$set(objekt.bilag_draft.bilagslinje, index, Object.assign({}, objekt.bilag_draft.bilagslinje[index], line))
    },
    recalcObjekt: function (objekt, withUnderhandPrice, fullRecalc, currLine) {
      // Recalc Objekt
      let index = objekt.bilag_draft.bilagslinje.findIndex(x => x.Varenr === objekt.Objektnr)
      let vidx = null
      let item = null
      let data = null
      let line = null

      // let Pris = withUnderhandPrice ? parseFloat(this.form.objektdata.Salgspris || 0) : parseFloat(this.currentObjektPris(objekt) || 0)
      let Pris = 0

      if (withUnderhandPrice) {
        // Here Salgspris has changed
        Pris = parseFloat(this.form.objektdata.Salgspris || 0)
      } else if (currLine) {
        // Ink mva has changed
        Pris = parseFloat(currLine.Beloptotal || 0)
      } else {
        // No line, hence we shall recalc with current objekt pris
        Pris = parseFloat(this.currentObjektPris(objekt) || 0)
      }

      if (index !== -1) {
        let vidx = this.vareList.findIndex(x => x.data.Varekode === 'OBJEKT')
        let item = this.vareList[vidx]
        let data = {
          Antall: 1,
          Pris: Pris,
          Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
          Varetype: 'O',
          Varenr: objekt.Objektnr,
          Beskrivelse: objekt.bilag_draft.bilagslinje[index].Beskrivelse || this.objektTitle,
          Internaldel: false,
          Internaledit: true
        }

        // Make line
        let line = this.makeVareLine(objekt, item, data, true)

        this.$set(objekt.bilag_draft.bilagslinje, index, Object.assign({}, objekt.bilag_draft.bilagslinje[index], line))
      }

      if (fullRecalc) {
        // If we are recalculating after mvafri changed, we skip the salar update here...
        return
      }

      // Now recalc salar
      index = objekt.bilag_draft.bilagslinje.findIndex(x => x.Varenr === 'SALÆR')

      if (index !== -1) {
        vidx = this.vareList.findIndex(x => x.data.Varekode === 'SALÆR')
        item = this.vareList[vidx]

        let Pris = parseFloat(this.currentObjektPris(objekt) || 0)
        /*
        if (this.currentObjektPris(objekt) < 1600 && this.hasBKH(objekt)) {
          Pris = Pris * (25 / 100)
        } else if (SALAR_MAP.hasOwnProperty(objekt.Kategori)) {
          if (!SALAR_MAP[objekt.Kategori]) {
            Pris = 0
          } else if (this.hasBKH(objekt)) {
            Pris = Pris * ((SALAR_MAP[objekt.Kategori] * 1.25) / 100)
          } else {
            Pris = Pris * (SALAR_MAP[objekt.Kategori] / 100)
          }
        }
        */
        if (this.currentObjektPris(objekt) < 1600 && this.hasBKH(objekt)) {
          Pris = Pris * (25 / 100)
        } else if (SALAR_MAP.hasOwnProperty(objekt.Kategori)) {
          if (!SALAR_MAP[objekt.Kategori]) {
            Pris = 0
          } else if (this.hasBKH(objekt)) {
            Pris = Pris * ((SALAR_MAP[objekt.Kategori] * 1.25) / 100)
          } else {
            Pris = Pris * (SALAR_MAP[objekt.Kategori] / 100)
          }
        }

        // Remove percent from salar price
        if (this.form.Mvafri === 'T') {
          // Must increase by possible MVA, as it will be reduced in the makeVareLine method.
          if (Pris > 0 && item.data.Prisinclmva === 'T' && item.data.mva && item.data.mva.Mvapct) {
            Pris = Pris / ((100 + parseInt(item.data.mva.Mvapct)) / 100)
          }
        }

        data = {
          Antall: 1,
          Pris: Pris,
          Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Beskrivelse: objekt.bilag_draft.bilagslinje[index].Beskrivelse || item.data.Beskrivelse,
          Internaldel: false,
          Internaledit: true
        }

        // Make line
        line = this.makeVareLine(objekt, item, data, true)

        // Merge new data with old, and keep reactivity - hence Object assign
        this.$set(objekt.bilag_draft.bilagslinje, index, Object.assign({}, objekt.bilag_draft.bilagslinje[index], line))
      }
    },
    recalcSalar: function (objekt, currLine, mvaChanged) {
      // Now recalc salar
      const index = objekt.bilag_draft.bilagslinje.findIndex(x => x.Varenr === 'SALÆR')

      if (index !== -1) {
        const vidx = this.vareList.findIndex(x => x.data.Varekode === 'SALÆR')
        const item = this.vareList[vidx]

        // let Pris = parseFloat(this.currentSalarPris(objekt) || 0)
        // if (this.form.Mvafri === 'F') {
        //   // Must increase by possible MVA, as it will be reduced in the makeVareLine method.
        //   if (Pris > 0 && item.data.Prisinclmva === 'T' && item.data.mva && item.data.mva.Mvapct) {
        //     Pris = Pris * ((100 + parseInt(item.data.mva.Mvapct)) / 100)
        //   }
        // }

        let Pris = 0
        let MvaProcent = this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0

        if (mvaChanged) {
          // Must recalc to exclude mva
          if (this.form.Mvafri === 'T' && item.data.mva && item.data.mva.Mvapct) {
            Pris = currLine.Pris * ((100 + parseInt(item.data.mva.Mvapct)) / 100)
          } else {
            Pris = currLine.Pris
            // MvaProcent = item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0
          }
        } else {
          Pris = currLine.Beloptotal
          // Pris = parseFloat(this.currentSalarPris || 0)
        }

        const data = {
          Antall: 1,
          Pris: Pris,
          Mvapct: MvaProcent,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Beskrivelse: objekt.bilag_draft.bilagslinje[index].Beskrivelse || item.data.Beskrivelse,
          Internaldel: false,
          Internaledit: true
        }

        // Make line
        const line = this.makeVareLine(objekt, item, data, true)

        // Merge new data with old, and keep reactivity - hence Object assign
        this.$set(objekt.bilag_draft.bilagslinje, index, Object.assign({}, objekt.bilag_draft.bilagslinje[index], line))
      }
    },
    addSalar: function (objekt) {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'SALÆR')

      if (index === -1) {
        return
      }

      const item = this.vareList[index]
      let Pris = parseFloat(objekt.Salgspris)
      if (this.currentObjektPris(objekt) < 1600 && this.hasBKH(objekt)) {
        Pris = Pris * (25 / 100)
      } else if (SALAR_MAP.hasOwnProperty(objekt.Kategori)) {
        if (!SALAR_MAP[objekt.Kategori]) {
          Pris = 0
        } else if (this.hasBKH(objekt)) {
          Pris = Pris * ((SALAR_MAP[objekt.Kategori] * 1.25) / 100)
        } else {
          Pris = Pris * (SALAR_MAP[objekt.Kategori] / 100)
          // Pris = Pris * (SALAR_MAP[objekt.Kategori] / 100)
        }
      }

      const data = {
        Antall: 1,
        Pris: Pris,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: false,
        Internaledit: true
      }

      // Make line
      const line = this.makeVareLine(objekt, item, data)
      objekt.bilag_draft.bilagslinje.push(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    addKunstnersavgift: function (objekt, deletable) {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'BKH')
      this.bkh = this.currentObjektPris(objekt) >= 1600

      if (index === -1) {
        return
      }

      const item = this.vareList[index]
      const data = {
        Antall: 0.05,
        Pris: this.currentObjektPris(objekt) >= 1600 ? parseFloat(this.currentObjektPris(objekt) || 0) + parseFloat(this.currentSalarPris(objekt) || 0) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: deletable,
        Internaledit: false
      }

      // Make line
      const line = this.makeVareLine(objekt, item, data)
      objekt.bilag_draft.bilagslinje.push(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    addVare: function (objekt, item) {
      // Find index of vare in list
      const index = this.vareList.findIndex(x => x.data.Vareid === item.data.Vareid)

      if (index === -1) {
        this.$helpers.showErrorAlert('Feil', 'Kunne ikke finne vare')
        return
      }

      if (item.data.Varekode === 'BKH') {
        this.addKunstnersavgift(objekt, true)
        return
      }

      if (item.data.Varekode === getLagerleieVarekode(objekt.Avdelingsid)) {
        this.addLagerleie(objekt, true)
        return
      }

      const data = {
        Antall: 1,
        Pris: item.data.Pris ? parseFloat(item.data.Pris) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: true,
        Internaledit: true
      }

      // Make line
      const line = this.makeVareLine(objekt, item, data)
      objekt.bilag_draft.bilagslinje.push(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    addAuksjonsHonorar: function (objekt) {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'FOTO')

      if (index === -1) {
        return
      }
      const item = this.vareList[index]

      const data = {
        Antall: 1,
        Pris: parseFloat(objekt.Fotokostnad),
        Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: true,
        Internaledit: true
      }

      const line = this.makeVareLine(objekt, item, data)

      objekt.bilag_draft.bilagslinje.push(line)

      this.$set(this.vareOptionsUsed, objekt.Objektnr + ':' + item.data.Varekode, true)
    },

    addLagerLeie: function (objekt) {
      const index = this.vareList.findIndex(x => x.data.Varekode === getLagerleieVarekode(objekt.Avdelingsid))

      if (index === -1) {
        return
      }

      const lagerleieWeeks = this.getLagerleieWeeks(objekt)

      if (!lagerleieWeeks) {
        return
      }

      const item = this.vareList[index]
      const data = {
        Antall: lagerleieWeeks.weeks,
        Pris: item.data.Pris ? parseFloat(item.data.Pris) : 0,
        Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse + ' (' + lagerleieWeeks.from + ' - ' + lagerleieWeeks.till + ')',
        Internaldel: true,
        Internaledit: true
      }

      const line = this.makeVareLine(objekt, item, data)

      objekt.bilag_draft.bilagslinje.push(line)

      this.$set(this.vareOptionsUsed, objekt.Objektnr + ':' + item.data.Varekode, true)
    },

    delVare: function (objekt, line) {
      const index = objekt.bilag_draft.bilagslinje.findIndex(i => i.Internalid === line.Internalid)

      if (index === -1) {
        return
      }

      objekt.bilag_draft.bilagslinje.splice(index, 1)

      this.$delete(this.vareOptionsUsed, objekt.Objektnr + ':' + line.Varenr)
    },

    makeVareLine: function (objekt, vare, data, onlyRecalc) {
      // Caclulate some values, that are common for all types
      let Pris = data.Pris || 0

      // // CHANGE: Something sketchy with the !this.hasBKH(objekt)
      // if (this.form.Mvafri === 'F') {
      //   if (!this.hasBKH(objekt) || vare.data.Mvakode !== 'BKH') {
      //     if (Pris > 0 && vare.data.Prisinclmva === 'T' && data.Mvapct) {
      //       Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
      //     }
      //   }
      // }

      // const Belop = data.Antall * Pris
      // const Mvabelop = Belop * (this.form.Mvafri === 'F' && data.Mvapct ? (data.Mvapct / 100) : 0)

      if (!onlyRecalc) {
        if (this.form.Mvafri === 'F') {
          if (!this.hasBKH(objekt) || vare.data.Mvakode !== 'BKH') {
            // eslint-disable-next-line
            if (Pris != 0 && vare.data.Prisinclmva === 'T' && data.Mvapct) {
              Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
            }
          }
        }
      } else {
        if (this.form.Mvafri === 'F') {
          if (!this.hasBKH(objekt) || vare.data.Mvakode !== 'BKH') {
            // eslint-disable-next-line
            if (Pris != 0 && data.Mvapct) {
              Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
            }
          }
        }
      }

      let Mvabelop = 0
      let Belop = data.Antall * Pris

      if (onlyRecalc && data.Varenr === 'SALÆR') {
        Mvabelop = Belop * (data.Mvapct / 100)
      } else if (this.form.Mvafri === 'F' && data.Mvapct) {
        Mvabelop = Belop * (data.Mvapct / 100)
      }

      // const Mvabelop = Belop * (this.form.Mvafri === 'F' && data.Mvapct ? (data.Mvapct / 100) : 0)

      const Beloptotal = Belop + Mvabelop

      let line = {
        Antall: data.Antall,
        // Pris: accounting.formatNumber(Pris, { precision: 2, thousand: '' }),
        // Belop: accounting.formatNumber(Belop, { precision: 2, thousand: '' }),
        // Mvagrunnlag: accounting.formatNumber(Belop, { precision: 2, thousand: '' }),
        // Mvabelop: accounting.formatNumber(Mvabelop, { precision: 2, thousand: '' }),
        // Beloptotal: accounting.formatNumber(Belop + Mvabelop, { precision: 2, thousand: '' }),
        Pris: accounting.formatNumber(Pris, {precision: 2, thousand: ''}),
        Belop: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        Mvagrunnlag: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        Mvabelop: accounting.formatNumber(Mvabelop, {precision: 2, thousand: ''}),
        Beloptotal: accounting.formatNumber(Beloptotal, {precision: 2, thousand: ''}),

        Mvakode: this.form.Mvafri === 'F' ? vare.data.Mvakode : null,
        Mvapct: this.form.Mvafri === 'F' && data.Mvapct ? data.Mvapct : null,
        Mvatype: this.form.Mvafri === 'F' && vare.data.mva ? vare.data.mva.Mvatype : null,
        Beskrivelse: data.Beskrivelse,
        Bokforgruppekode: vare.data.bokforgruppe ? vare.data.bokforgruppe.Bokforgruppekode : '',
        Enhetskode: vare.data.Enhetskode,
        Vareid: vare.data.Vareid,
        Varenr: data.Varenr,
        Varetype: data.Varetype
      }

      if (!onlyRecalc) {
        line.Avgiftpct = null
        line.Bilagsid = null
        line.Bilagslinjeid = null
        line.Katalognr = null
        line.Linjenr = null
        line.Rabatbelop = null
        line.Rabatpct = null
        line.eurokurs = null
        line.Internalid = 'new-' + (objekt.Objektnr + '-' + objekt.bilag_draft.bilagslinje.length)
        line.Internaltype = 'new'
        line.Internaldel = data.Internaldel
        line.Internaledit = data.Internaledit
        line.Gruppe = objekt.Kontraktnr + '-' + String(objekt.Lopenr).padStart(3, '0')
        line.Objekt = objekt.Objektid
        line.Utlevdato = objekt.Lev_dato
      }

      return line
    },
    sortLinevalues: function (a, b) {
      let aText = a.data.Beskrivelse || a.val
      let bText = b.data.Beskrivelse || b.val
      return aText.localeCompare(bText)
    },
    getVarePopoverOptions: function (objekt) {
      // Get vare options list for an objekt
      return this.vareList.filter((i) => {
        if (i.data.Varekode === 'OBJEKT' || i.data.Varekode === 'SALÆR' || i.data.Varekode === 'OPPGJØR' || i.data.Varekode === 'FOTO' || i.data.Varekode === 'BKH') {
          return false
        }

        if (i.data.Varekode === getLagerleieVarekode(objekt.Avdelingsid) && this.getLagerleieWeeks(objekt) === null) {
          return false
        }

        if (this.vareOptionsUsed.hasOwnProperty(objekt.Objektnr + ':' + i.data.Varekode)) {
          return false
        }

        return true
      })
    },
    isVarePopoverActive: function (objektnr) {
      // Check if vare popover is active for an objekt
      return this.varePopoverActive.hasOwnProperty(objektnr)
    },
    toggleVarePopover: function (objektnr) {
      // Toggle vare option popover for an objekt
      if (this.varePopoverActive.hasOwnProperty(objektnr)) {
        this.$delete(this.varePopoverActive, objektnr)
      } else {
        this.$set(this.varePopoverActive, objektnr, true)
      }

      this.formPopoverActive = false
    },

    toggleFormPopover: function () {
      this.formPopoverActive = !this.formPopoverActive
      this.varePopoverActive = {}
    },

    getLagerleieWeeks: function (objekt) {
      // Check objekt
      if (!objekt.Lagerleieinfo || !objekt.Lagerleiedato) {
        return null
      }

      // Also check innlevav
      if (!objekt.innlevav || !objekt.innlevav.SendLagerleieinfo) {
        return null
      }

      const today = moment().format('YYYY-MM-DD')
      const ldato = moment(moment(objekt.Lagerleiedato).format('YYYY-MM-DD'))
      const diff = ldato.diff(today)

      // Only if today or less than today's date
      if (diff <= 0) {
        const totd = Math.abs(moment.duration(diff).as('days'))
        const totw = Math.floor(totd / 7) + ((totd % 7) > 0 ? 1 : 1)

        //  weeks from object
        const weeks = objekt.lagerleie_weeks ? objekt.lagerleie_weeks : totw

        return {
          weeks: weeks,
          from: ldato.format('YYYY-MM-DD'),
          till: today
        }
      }

      return null
    },

    openSaveModal: function () {
      let data = this._.clone(this.form)

      this.openModal('multi-invoice-modal',
        {
          data: data,
          objektlist: this.objektWithBilag,
          internalWindow: true
        },
        'split'
      )
    },
    onKundeAddressUpdated: function (data) {
      this.$set(this.form.objektdata, 'Mottaker', this._.cloneDeep(data))

      bus.$emit('kunde-merged', data)
    },
    hideMultiInvoice: function () {
      bus.$emit('hide-kontrakt-invoice-ar')
      bus.$emit('before-leave-page')
      bus.$emit('switchKundeFakturerMultipleOff')
      this.$router.push({path: '/kunde/' + this.kunde.Kundenr})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeFakturerMultiple.vue